import sample_01 from './100_51325.jpg';

export const dynamicFlameExtremeImpressions = {
    sample_01,
};
